import { globalColorPalette1 } from "@gago/frame/es/colors/default";
import { GlobalColorPalette } from "@gago/frame";

/** 自定义颜色
 * @author James Zhang
 */
export const colorPalette: GlobalColorPalette = {
  ...globalColorPalette1,
  // mainColor: [
  //   "#f1f9ff",
  //   "#d7e8ff",
  //   "#b2d1ff",
  //   "#85b6ff",
  //   "#5c9dff",
  //   "#3076ed",
  //   "#1650b5",
  //   "#082e8d",
  //   "#162254",
  //   "#0d1330",
  // ],
  // secondaryColor: [
  //   "#f0f2f7",
  //   "#d9deef",
  //   "#fff9c7",
  //   "#ffed93",
  //   "#ffde67",
  //   "#fac641",
  //   "#909748",
  //   "#222361",
  //   "#12123b",
  //   "#070614",
  // ],
};
export const pieChartColor = { ...colorPalette, subColor: ["#00fdff", "#1d9bff", "#ffd164", "#ff7b2f", "#ff51a2", "#009fb8", "#7433ff"] };
export const pieChartColor2 = { ...colorPalette, subColor: ["#ff7b2f", "#ff51a2", "#ffd164"] };
/** 图表配置颜色 */
export const chartStyle = {
  /** 主要文字颜色，包含类目轴, 主轴的label  */
  mainTextColor: "#00cae0",
  /** 主要文字大小，包含类目轴 */
  mainTextSize: 12,
  /** 类目轴颜色, 主轴的轴线 */
  mainAxisColor: "#00cae0",
  /** 次要文字颜色，包含值轴，图例； 副轴的label */
  secondaryTextColor: "#009fb8",
  /** 次要文字大小，包含值轴，图例 */
  secondaryTextSize: 12,
  /** 值轴颜色, 副轴的轴线 */
  secondaryAxisColor: "rgba(176, 225, 255, 0)",
  /** 分割线颜色 */
  splitLineColor: "rgba(0, 221, 255, 0.2)",
  /** 提示主要文字颜色 */
  tooltipMainTextColor: "#00cae0",
  /** 提示框次要文字颜色 */
  tooltipSecondaryTextColor: "#009fb8",
};
